import type { BaseURL, BaseURLMonitoringItem } from './types';

export function publicURLsForBase(base: Partial<BaseURL> | Partial<BaseURLMonitoringItem>) {
  const urls = Array.isArray(base.publicUrls) ? base.publicUrls.filter(Boolean) : [];
  const primary = String(base.publicUrl || '').trim();
  if (primary && !urls.includes(primary)) return [primary, ...urls];
  return urls.length > 0 ? urls : primary ? [primary] : [];
}

export function primaryPublicURL(base: Partial<BaseURL> | Partial<BaseURLMonitoringItem>) {
  return publicURLsForBase(base)[0] || String(base.publicUrl || '').trim();
}
